import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { ShieldCheckIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function WhatYouGetSection() {
  const {
    isExpired
  } = useCountdown();
  return <div className="grain-section w-full px-6 py-32 md:py-40 bg-white" data-id="element-417">
      <div className="max-w-6xl mx-auto space-y-32" data-id="element-418">
        {/* Chapter 4 */}
        <div className="space-y-16" data-id="element-419">
          <div className="flex flex-col md:flex-row md:items-center gap-8 mb-8" data-id="element-420">
            <div className="text-8xl md:text-9xl font-black text-teal-50 font-sans tracking-tighter" data-id="element-421">
              04
            </div>
            <div className="h-px w-24 bg-teal-100 hidden md:block" data-id="element-422"></div>
            <div data-id="element-423">
              <p className="text-xs text-teal-600 font-bold tracking-widest uppercase mb-3" data-id="element-424">
                Chapter Four
              </p>
              <h2 className="text-4xl md:text-6xl font-bold text-ink tracking-tight" data-id="element-425">
                Why This Offer Exists <br data-id="element-426" />
                <span className="text-teal-600" data-id="element-427">(And Why It Won't Last)</span>
              </h2>
            </div>
          </div>

          <div className="space-y-8 text-xl text-ink-light leading-relaxed font-light" data-id="element-428">
            <p data-id="element-429">
              Normally, this level of attention is reserved for our private
              transformation clients. The people investing $15,000 – $120,000 to
              have their entire biology rebuilt from the inside out.
            </p>
            <p data-id="element-430">
              But we wanted to create a way for a small number of people... To
              experience that same level of precision thinking... Without
              needing to commit to a full transformation program upfront.
            </p>

            <div className="space-y-10 pt-4" data-id="element-431">
              {/* Big headline */}
              <div className="text-center space-y-2" data-id="element-432">
                <p className="text-3xl md:text-4xl font-black text-ink tracking-tight leading-tight" data-id="element-433">
                  You're Getting a $15K–$40K Transformation Program...
                </p>
                <p className="text-2xl md:text-3xl font-black text-teal-600" data-id="element-434">
                  Built in ONE Session.
                </p>
              </div>

              <p className="text-xl text-ink-light font-light" data-id="element-435">
                Normally, when someone enrolls in a full transformation
                program... Here's what happens:
              </p>

              {/* Process steps */}
              <div className="space-y-3" data-id="element-436">
                {['Dr. Ali or Brenden reviews their entire biological history', "They spend 2–3 hours on a deep-dive session uncovering what's REALLY going on", 'They create a written Precision Cell Blueprint (the exact roadmap)', 'They provide ongoing support as the client implements'].map((step, i) => <div key={i} className="flex items-start gap-4 bg-page-bg rounded-2xl px-6 py-4 border border-black/5" data-id="element-437">
                    <span className="text-teal-500 font-black text-lg mt-0.5" data-id="element-438">
                      →
                    </span>
                    <p className="text-lg text-ink font-medium" data-id="element-439">{step}</p>
                  </div>)}
              </div>

              <p className="text-xl font-bold text-ink text-center" data-id="element-440">
                That's the SAME process you're getting here.
              </p>

              {/* The difference */}
              <div className="bg-page-bg rounded-[2rem] p-8 md:p-10 border border-black/5 shadow-inner space-y-4" data-id="element-441">
                <p className="text-lg text-ink-light font-light" data-id="element-442">
                  The only difference?
                </p>
                <p className="text-xl text-ink font-light" data-id="element-443">
                  You're not getting 3 months of hand-holding.
                </p>
                <p className="text-2xl font-bold text-ink" data-id="element-444">
                  You're getting the BLUEPRINT.
                </p>
                <div className="space-y-2 text-lg text-ink-light font-light pt-2" data-id="element-445">
                  <p data-id="element-446">The exact roadmap.</p>
                  <p data-id="element-447">
                    The step-by-step plan showing you what to do, when to do it,
                    and in what order.
                  </p>
                  <p className="font-medium text-ink" data-id="element-448">
                    Plus 30 days of basic implementation support so you're not
                    abandoned.
                  </p>
                </div>
              </div>

              {/* Credit offer */}
              <div className="bg-teal-50 border border-teal-100 rounded-[2rem] p-8 md:p-10 space-y-4" data-id="element-449">
                <p className="text-xl text-ink font-light" data-id="element-450">
                  And if you decide you <span className="font-bold" data-id="element-451">WANT</span>{' '}
                  the full hands-on experience?
                </p>
                <p className="text-lg text-ink-light font-light" data-id="element-452">
                  You can apply the full $1,500 towards a transformation program
                  within 30 days.
                </p>
                <p className="text-2xl font-black text-teal-600" data-id="element-453">
                  Which means this session basically becomes FREE.
                </p>
              </div>

              {/* Math breakdown */}
              <div className="space-y-6" data-id="element-454">
                <p className="text-2xl font-black text-ink tracking-tight" data-id="element-455">
                  Let's Do the Math:
                </p>
                <div className="space-y-3" data-id="element-456">
                  <div className="flex items-center justify-between gap-4 py-4 border-b border-black/5" data-id="element-457">
                    <span className="text-lg text-ink-light font-light" data-id="element-458">
                      Full Transformation Program
                    </span>
                    <span className="text-xl font-bold text-ink" data-id="element-459">
                      $15,000 – $40,000
                    </span>
                  </div>
                  <div className="flex items-center justify-between gap-4 py-4 border-b border-black/5" data-id="element-460">
                    <span className="text-lg text-ink-light font-light" data-id="element-461">
                      Meeting With the Master: ADVANCED (Normal Price)
                    </span>
                    <span className="text-xl font-bold text-ink line-through decoration-red-400" data-id="element-462">
                      $5,000
                    </span>
                  </div>
                  <div className="flex items-center justify-between gap-4 py-4 bg-teal-50 rounded-2xl px-6 border border-teal-100" data-id="element-463">
                    <span className="text-lg font-bold text-teal-700" data-id="element-464">
                      Launch Special Price
                    </span>
                    <span className="text-3xl font-black text-teal-600" data-id="element-465">
                      $1,500
                    </span>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#1a1a2e] to-[#0f172a] rounded-[2rem] p-8 md:p-10 space-y-3 text-center" data-id="element-466">
                  <p className="text-white/60 text-sm font-bold tracking-widest uppercase" data-id="element-467">
                    Your Savings
                  </p>
                  <p className="text-2xl md:text-3xl font-black text-white" data-id="element-468">
                    $13,500 to $38,500{' '}
                    <span className="text-white/60 font-light text-xl" data-id="element-469">
                      vs. a full program
                    </span>
                  </p>
                  <p className="text-teal-400 font-bold text-lg" data-id="element-470">
                    + $3,500 saved vs. what this costs after the deadline
                  </p>
                </div>
              </div>

              {/* Closing punchy copy */}
              <div className="space-y-4 text-center pt-4" data-id="element-471">
                <p className="text-2xl font-black text-ink" data-id="element-472">So yeah.</p>
                <p className="text-xl text-ink-light font-light" data-id="element-473">
                  This is borderline stupid.
                </p>
                <p className="text-xl font-bold text-ink" data-id="element-474">
                  But we're doing it anyway.
                </p>
                <p className="text-xl text-ink-light font-light max-w-2xl mx-auto leading-relaxed" data-id="element-475">
                  Because we want to give a small number of people... The chance
                  to experience what precision thinking actually looks like...
                  Without needing to drop $15K+ upfront.
                </p>
              </div>
            </div>

            <div className="bg-page-bg p-12 rounded-[3rem] border border-black/5 my-10 space-y-6 shadow-inner" data-id="element-476">
              <p className="text-2xl font-bold text-ink" data-id="element-477">
                So we created Meeting With the Master: ADVANCED.
              </p>
              <p data-id="element-478">
                It's designed to give you the clarity and roadmap you've been
                searching for... In a single intensive session.
              </p>
              {isExpired ? <p className="text-3xl font-bold text-teal-600" data-id="element-479">
                  Available now for $5,000.
                </p> : <p className="text-3xl font-bold text-teal-600" data-id="element-480">
                  Normally priced at $5,000. But for 3 days only... You can get
                  the full Advanced experience for just $1,500.
                </p>}
              <p className="text-sm font-bold uppercase tracking-widest text-ink/40" data-id="element-481">
                The same price as our basic consult.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}